export function validate(data, rules) {
  const errorMessages = {};

  for (const [field, validation] of Object.entries(rules)) {
    if (data[field]) {
      const message = validation(data[field]);
      if (message) {
        errorMessages[field] = message;
      }
    }
  }

  return errorMessages;
}
